<template>
  <header class="mt-2">
    <div class="d-flex justify-content-between align-items-center">
      <router-link
        id="logo"
        to="/"
      >
        <img
          v-if="appName === 'Planetajob'"
          class="logo"
          src="@/assets/planetajob_logo.png"
        >
        <img
          v-if="appName === 'Aicad Jobs'"
          class="logo"
          src="@/assets/aicad_logo.png"
        >
      </router-link>
      <div class="portalHeadline">
        {{ isLocalEnv ? 'LOCAL DEVELOPMENT' : '' }}
      </div>
      <LanguagePicker :dark="true" />
      <div
        id="right-menu"
        class="header-buttons my-auto"
      >
        <div v-if="!$auth.check() && $route.name != 'Login' && $route.name != 'Register'">
          <b-button
            variant="info"
            class="buttonas buttonas--inverted mr-2"
            style="text-transform: uppercase;"
            @click="$router.push({ name: 'Login' })"
          >
            {{ $t('generic.sign-in', 'Sign in') }}
          </b-button>
          <b-button
            variant="info"
            class="buttonas mr-2 register"
            style="text-transform: uppercase;"
            @click="$router.push({ name: 'Register' })"
          >
            {{ $t('generic.sign-up', 'Sign up') }}
          </b-button>
        </div>
        <div
          v-if="$auth.check()"
          class="logged-in"
        >
          <router-link
            v-if="$route.name != 'my-account'"
            :to="{name: 'my-account', query: { profile: true }}"
            class="user-name"
            v-text="$auth.user().first_name"
          />
          <a
            id="logout"
            @click="logout"
            v-text="$t('generic.sign-off', 'Sign off')"
          />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import LanguagePicker from "@/components/LanguagePicker";
export default {
  components: {LanguagePicker},
  computed: {
    isLocalEnv() {
      return process.env.NODE_ENV === 'development';
    },
    appName() {
      return process.env.VUE_APP_NAME;
    }
  },
  methods: {
    logout() {
      this.$auth.logout({
        makeRequest: true,
        params: {}, // data: {} in axios
        success: function () {},
        error: function () {},
        redirect: '/login',
      });
    }
  }
}
</script>

<style lang="scss">
  header {
    padding: 20px 40px;
    background: #009090;
    height: 70px;
    box-shadow: 2px 2px 2px rgba(0,0,0,0.2);
  }

  .header-buttons {
    width: 100%;
    text-align: right;
  }

  #logout {
    cursor: pointer;
  }


  #right-menu {
    white-space: nowrap;

    a {
      margin-right: 10px;
      font-size: 0.9rem;
      color: #d1d8dc !important;
    }
  }

  .logo {
    height: 35px;
  }

  .buttonas {
    background: #009090;
    border: 1px solid #009090;
    font-weight: 400;
    font-size: 0.8rem !important;
    padding: 4px 10px;
    transition: 0.3s ease;

    @media screen and (max-width: 420px){
      &.register {
        display: none;
      }
    }

    &:hover {
      background: #006060 !important;
      color: white !important;
      border: 1px solid #006060;
      transition: 0.3s ease;
    }

    &--inverted {
      background: transparent !important;
      border: 1px solid #fff !important;
      transition: 0.3s ease;
    }
  }

  @media screen and (max-width: 420px) {
    .user-name {
      display: none;
    }
  }

</style>
